import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import LineCard from './line-card';
import Loadingcomponent from '../loader/loadingcomponent';
import { EndPointUserDetails } from '../../services/common/endpoints';
import {
  setChildMsisdn,
  setISB2BCPRNumber,
  setNotificationsArray,
  setSelectedNumber,
  setcustomerprofile,
  setrnuserdetails,
} from '../../reducer/actions';
import {
  doFunct,
  setItem,
  setItemInSessionStorage,
} from '../../services/common/utils';
import { isB2BCPRNumber } from '../../services/common/CommonUtils';
import { setRefetchHomePage } from '../../reducer/utilitySlice';
import { useQuery } from 'react-query';
import { CHILDMSISDN, SELECTED_MSISDN } from '../../services/common/Constants';
import { setSelectedNumber as setSelectedNumberAction } from '../../reducer/assistantSlice';

export default function BottomSlider({ show, title, message, toggleModal }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [lines, setLines] = useState([]);
  const [loading, setLoading] = useState(false);
  const [enableProfileAPIs, setenableProfileAPIs] = useState(false);
  const msisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);

  const { queryAccountData } = useSelector((state) => state.userdata);

  useEffect(() => {
    if (queryAccountData?.response?.linkedmsisdns?.length > 0) {

      let selectedNumberAssist =   queryAccountData?.response?.linkedmsisdns?.find(
        (line)=>line.cmsisdn == msisdn
      );
      dispatch(setSelectedNumberAction(selectedNumberAssist));

      var _loginList =   queryAccountData?.response?.linkedmsisdns?.filter(
        (line)=>line.cmsisdn == msisdn
      );
      var _msisdnsList =   queryAccountData?.response?.linkedmsisdns?.filter(
        (line) => !line.NonAccountMsisdn && line.cmsisdn != msisdn
      );

           setLines(
            [].concat(_loginList[0],_msisdnsList)
          );
    }
  }, [queryAccountData]);

  const userDetailsApi = useQuery(
    [
      'customerprofile',
      'customerprofile/get',
      { source: 'homepage', sec: 'splash' },
      {},
      false,
    ],
    {
      retry: false,
      retryOnMount: true,
      enabled: enableProfileAPIs,
      cacheTime: 0,
      staleTime: 0,
    }
  );

  const rnuserdetails = useQuery(
    ['rn_userdetails', EndPointUserDetails.url, EndPointUserDetails.data, {}, false],
    {
      retry: false,
      retryOnMount: true,
      enabled: enableProfileAPIs,
      cacheTime: 0,
      staleTime: 0,
    }
  );

  useEffect(() => {
    if (userDetailsApi.isSuccess && userDetailsApi?.data?.data) {
      dispatch(setcustomerprofile(userDetailsApi?.data?.data?.response));
      setItemInSessionStorage(
        'Customerid',
        userDetailsApi?.data?.data?.response?.CustomerID
      );
      try {
        var _isB2BCpr = isB2BCPRNumber(userDetailsApi?.data?.data?.response);
        dispatch(setISB2BCPRNumber(_isB2BCpr));
      } catch {}
      try {
        dispatch(setNotificationsArray('clearNotification'));
        // GTM_Change_Msisdn("Manage-lines", msisdn, userDetailsApi?.data?.data?.response?.CustomerID, logintype, "Success");
        // CT_ChangeNumber(loggedMsisdn)
      } catch {}
      // try{
      //   GTM_Change_Msisdn("Manage-lines", msisdn, userDetailsApi?.data?.data?.response?.CustomerID, logintype, "Success");
      // }catch{}
    }
    if (rnuserdetails.isSuccess && rnuserdetails?.data?.data) {
      dispatch(setrnuserdetails(rnuserdetails?.data?.data?.response));
    }
    if (rnuserdetails?.isSuccess && userDetailsApi?.isSuccess) {
      //alert("issuccess");
      setLoading(false);
      navigate('/');
      try {
        dispatch(setNotificationsArray('clearNotification'));
      } catch {}

      toggleModal();
      dispatch(setRefetchHomePage(true));
      //   navigate("/home/index", {state:{isChildMsisdn: "true"}} );
    }
  }, [
    userDetailsApi?.data?.data,
    userDetailsApi.isSuccess,
    rnuserdetails?.data?.data,
    rnuserdetails.isSuccess,
  ]);

  const managelineselectclick = (x) => {
    if (x.NonAccountMsisdn == true) {
      return;
    } else {
      dispatch(setSelectedNumberAction(x));

      global.userdetails = null;
      let encMobile = doFunct(x.msisdn, 'MOBAPI');
      global.setchildmsisdn = x.msisdn;
      global.setchildmsisdn_encrypt = encMobile;
      setItem(CHILDMSISDN, encMobile);
      setItem(SELECTED_MSISDN, x.cmsisdn);
      try {
        setItemInSessionStorage('pre_id', '965' + msisdn);
        dispatch(setSelectedNumber(x.cmsisdn));
        dispatch(setChildMsisdn(x.cmsisdn));
      } catch (e) {}
      global.notificationsCards = null;
      global.notificationLength = 0;
      global.balancenotify = null;
      global.customerprofile_image = '';
      global.customerprofile = null;
      global.UniqueToken = 't' + new Date().getTime() + 'm';
      global.UniqueTokenProfile = 't' + new Date().getTime() + 'm';
      try {
        setLoading(true);
        setenableProfileAPIs(true);
      } catch (e) {}
    }
  };

  const handleManageLines = () => {
    toggleModal();
    navigate('/manage-lines');
  };

  return (
    <Modal
      show={show}
      backdrop="true"
      className="modal bottom_modal animated  slideInUp faster popup2 country-accro-comp1 sp16-modal-bounce-effect"
      onHide={toggleModal}
    >
      <Modal.Header className="border-0 p-0">
          <div className="popup-top-line"></div>
          <h6 className="dir-ltrl">{queryAccountData?.response?.popuptitle}</h6>

          <button className="badges-close-button" onClick={toggleModal}>
            <img
              src={process.env.PUBLIC_URL + '/assets/images/cross_dark.svg'}
              alt=""
              title=""
            />
          </button>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p>{queryAccountData?.response?.popupdesc}</p>

          <ul
            className="account_list"
            style={{ maxHeight: '214px', overflow: 'auto' }}
          >
            {loading && <Loadingcomponent />}
            {!(loading && lines?.length > 0) &&
              lines?.map((line, index) => (
                <LineCard
                  key={`line-${index}`}
                  item={line}
                  toggleModal={toggleModal}
                  setLoading={setLoading}
                  managelineselectclick={managelineselectclick}
                />
              ))}
          </ul>

          <hr />

          <h6 className="dir-ltrl mb-2">{queryAccountData?.response?.popupbtmtitle}</h6>
          <p>{queryAccountData?.response?.popupbtmdesc}</p>

          <div className="mt-4">
            <button
              type="button"
              className="custom_btn custom_btn_primary btn_block text-initials"
              data-bs-dismiss="modal"
              onClick={handleManageLines}
              disabled={loading}
            >
              {queryAccountData?.response?.popupbtntext}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
